var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Track } from 'livekit-client';
import VideoComponent from './video';
import { useAppSelector } from '../../../store';
import { activeSpeakersSelector } from '../../../store/slices/activeSpeakersSlice';
const VideoParticipant = ({ participantType, participant, }) => {
    _react_refresh_temp_2();
    const isSpeaking = useAppSelector((state) => activeSpeakersSelector.selectById(state, participant.identity));
    const renderVideoElms = useMemo(() => {
        const elements = [];
        participant.tracks.forEach((track) => {
            if (track.source === Track.Source.Camera) {
                const elm = (_jsxs("div", { className: "video-camera-item-inner", children: [_jsxs("div", { className: "name", children: [participant.name, " ", participantType.isLocal ? '(me)' : null] }), _jsx(VideoComponent, { userId: participant.identity, track: track })] }, track.trackSid));
                elements.push(elm);
            }
        });
        return elements;
    }, [participant]);
    return (_jsx("div", { className: `video-camera-item relative ${isSpeaking ? 'speaking' : ''} ${participantType.isAdmin ? 'admin' : 'participants'}`, children: renderVideoElms }));
};
_react_refresh_temp_1 = VideoParticipant;
$RefreshReg$(_react_refresh_temp_1, "VideoParticipant");
_react_refresh_temp_2(VideoParticipant, "oNGutgoWwlvETGOxf721yN03Mts=", false, () => [useAppSelector]);
export default VideoParticipant;
